const b64EncodeUnicode = (str) => {
    // SOURCE: https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode('0x' + p1)));
};

const b64DecodeUnicode = (str) => {
    // SOURCE: https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('')
                                       .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                                       .join(''));
};

export function encode (data) {
    return b64EncodeUnicode(JSON.stringify(data));
}

export function decode (string) {
    return JSON.parse(b64DecodeUnicode(string));
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Base64.js